<template>
    <b-row class="OT-landing-v2 no-gutters">
        <b-col>
            <!-- welcome -->
            <b-row class="OTWelcome no-gutters">
                <WelcomeUser></WelcomeUser>
            </b-row>
            <!-- welcome  -->

            <!-- for later resume work
            <ResumeWork></ResumeWork>-->
            <!-- resume work -->

           <!-- 
               for later
               <b-row class="OTMainReportTimeRange no-gutters">
                <b-col cols="12  ml-2 mr-2">
                    <h1 class="OTReportRangeTitle">{{this.ReportFrom}}</h1>
                    <b-dropdown variant="link" class="OTlastReport">
                        <template slot="button-content">{{this.ReportFrom}}</template>
                        <b-dropdown-item @click>Last 7 days</b-dropdown-item>
                        <b-dropdown-item @click>Last 30 days</b-dropdown-item>
                        <b-dropdown-item @click>Last 6 months</b-dropdown-item>
                        <b-dropdown-item @click>Last year</b-dropdown-item>
                    </b-dropdown>
                   
                </b-col>
            </b-row> -->

            <!-- main -->
            <b-row class="OTMainLanding no-gutters">
                <b-col cols="12">
                     
                     <b-row class="OTLandingSpace ot-main-panel OTMainLanding ml-2 mr-2">
                        <b-col cols="9" class="OTMainLeftPart">
                            <!-- left Inner -->
                            <b-row class="mt-2 mb-0 ml-1 mr-1">
                               
                                <b-col cols="12">
                                    <span class="OTLandingTitleS1">Processing</span>
                                    <!--
                                    <b-alert class="OTAlert OTAlertError OTAlertErrorLanding" show>
                                        <span class="ot-icon-alert-title"></span>
                                        2 Events Errors
                                    </b-alert>s
                                    -->
                                </b-col>
                               
                                 <b-col cols="6">
                                    <h1 class="OTLandingTitleS2 OTReportRangeTitle">{{this.ReportFrom}}</h1>

                                </b-col>
                                 <b-col cols="6" class="text-right">
                                    <a href="#/dashboard" class="OTvisteDashboard">Visit the activity dashboard for more details</a>
                                    
                                </b-col>

                            </b-row>

                            <jobStatus></jobStatus>

                            <mainGraph></mainGraph>

                            <b-row>
                                <b-col class="mt-4 mb-2 ml-3 mr-3">
                                    <b-row>
                                        <b-col cols="4">
                                            <span class="OTLandingTitleS2">
                                                Last Modified Projects
                                                <a
                                                    href="javascript(void)"
                                                    @click.prevent="$eventBus.$emit('create-project')"
                                                >
                                                    <span
                                                        title="Create Project"
                                                        class="ot-icon-addproject"
                                                        v-b-tooltip.hover
                                                    ></span>
                                                </a>
                                                <a href="#/projects">
                                                    <span
                                                        class="ot-icon-manage-list-project"
                                                        title="Manage Projects"
                                                        v-b-tooltip.hover
                                                    ></span>
                                                </a>
                                            </span>
                                            <LastProjects></LastProjects>
                                        </b-col>
                                        <b-col cols="4">
                                            <span class="OTLandingTitleS2">
                                               Last Modified Jobs
                                                <a
                                                    href="javascript(void)"
                                                    @click.prevent="$eventBus.$emit('create-job')"
                                                >
                                                    <span
                                                        title="Create Job"
                                                        v-b-tooltip.hover
                                                        class="ot-icon-addjob"
                                                    ></span>
                                                </a>
                                                <a href="#/jobs">
                                                    <span
                                                        title="Manage Jobs"
                                                        class="ot-icon-manage-list-job"
                                                        v-b-tooltip.hovers
                                                    ></span>
                                                </a>
                                            </span>
                                            <LastJobs></LastJobs>
                                        </b-col>
                                        <b-col cols="4">
                                            <span class="OTLandingTitleS2">Running Jobs</span>
                                            <RunningJobs></RunningJobs>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <!--- End left Inner -->
                        </b-col>
                        <b-col cols="3" class="OTMainRightPart">
                            <b-row class="mt-2 mb-2 ml-2 mr-2">
                                <b-col cols="12">
                                    <span class="OTLandingTitleS1">Enrichment</span>
                                </b-col>
                                <b-col cols="12" class="OTAnnoationBlock">
                                    <!-- start annoation data -->
                                    <span class="OTLandingTitleS2">Authority Files</span>
                                     <annotationAF></annotationAF>
                                    <!--<b-row>
                                        <b-col class="OTgraphListMore">
                                            <a href>Manage Authority Files</a>
                                        </b-col>
                                    </b-row>-->
                                </b-col>
                                <b-col cols="12" class="OTAnnoationBlock">
                                    <!-- start annoation data -->
                                    <span class="OTLandingTitleS2">Knowledge Bases</span>
                                    <annotationKB></annotationKB>
                                    
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <!-- main -->
        </b-col>
    </b-row>
</template>

<script>
import WelcomeUser from "./home/welcomeuser.vue";
//import ResumeWork from "./home/resumework.vue";
import jobStatus from "./home/jobStatus.vue";
import mainGraph from "./home/mainGraph.vue";
import LastProjects from "./home/Listmostrecentprojects.vue";

import RunningJobs from "./home/Listrunningjob.vue";

import LastJobs from "./home/Listmostrecentjobs.vue";
import annotationAF from "./home/annotationAF.vue";
import annotationKB from "./home/annotationKB.vue";

export default {
    components: {
        RunningJobs,
        WelcomeUser,
       // ResumeWork,
        mainGraph,
        jobStatus,
        LastJobs,
        LastProjects,
        annotationAF,
        annotationKB
    },
    data() {
        return {
            ReportFrom: "Report from Last 7 days"
        };
    }
};
</script>



